module.exports = __webpack_public_path__ + "public/img/Image not found.9dd257e3.jpg";